/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Icon, TooltipPosition, TooltipWrapper } from '@zapier/design-system';
import { ReactNode } from 'react';

const styleRoot = css`
  display: inline-block;

  & > [class][class][class][class][class][class] {
    vertical-align: text-bottom;
  }
`;

const styleFlex = css`
  display: flex;
`;

interface InfoIconTooltipProps {
  allowMultilineTooltip?: boolean;
  content: ReactNode;
  position?: TooltipPosition;
  size?: string;
}

export function InfoIconTooltip({
  allowMultilineTooltip,
  content,
  position,
  size = '20px',
}: InfoIconTooltipProps) {
  return (
    <div css={styleRoot}>
      <TooltipWrapper
        allowMultilineTooltip={allowMultilineTooltip}
        content={content}
        position={position}
      >
        {() => (
          <div css={styleFlex}>
            <Icon color="GrayWarm6" name="alertInfoFill" size={size} />
          </div>
        )}
      </TooltipWrapper>
    </div>
  );
}
